
<div class="objective-section">
    <div class="image-section" *ngIf="responsiveScreenService.isOrBigger('HD-s')">
        <img src="assets/images/reforestaction/objective.webp" />
    </div>

    <div class="content-section">
        <div class="title">
            {{ 'events.reforestaction.objective.title.l1' | translate }}
            <br>
            {{ 'events.reforestaction.objective.title.l2' | translate }}
        </div>
        <div class="image-section" *ngIf="responsiveScreenService.isOrSmaller('m')">
            <img src="assets/images/reforestaction/objective.webp" />
        </div>
        <div class="text">
            {{ 'events.reforestaction.objective.text' | translate }}
        </div>
    </div>
</div>